// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Profile_breadcrumb__1Jgjh"};